import { render, staticRenderFns } from "./CommentHistory.vue?vue&type=template&id=5fcb3cd1&scoped=true&"
import script from "./CommentHistory.vue?vue&type=script&lang=js&"
export * from "./CommentHistory.vue?vue&type=script&lang=js&"
import style0 from "./CommentHistory.vue?vue&type=style&index=0&id=5fcb3cd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb3cd1",
  null
  
)

export default component.exports